import withIsFeatureActive from "web/core/UNSAFE_featureFlags/withIsFeatureActive";

export default () => withIsFeatureActive("wishlist", "wishlist");
